/**
 * ventaProductoMapper.ts — Mapeo de línea de carrito/payload a VentaProducto.
 */
import type { VentaProducto } from "../types/caja.types";

/** Normaliza una línea del carrito o payload de venta al shape persistido. */
export const mapLineToVentaProducto = (
  p: {
    id?: string;
    productoId?: string;
    nombre?: string;
    quantity?: number;
    cantidad?: number;
    precioUnitario?: number;
    precio?: number;
    precioLista?: number;
    precioMayorista?: number;
    esMayorista?: boolean;
    esVIP?: boolean;
    vipDescuentoPct?: number;
    tieneIVA?: boolean;
    porcentajeIVA?: number;
    peso?: number;
    precioPorKilo?: number;
    variantKey?: string;
    variantesSeleccionadas?: VentaProducto["variantesSeleccionadas"];
    skuVariante?: string;
    modificadoresSeleccionados?: VentaProducto["modificadoresSeleccionados"];
    modifierKey?: string;
    isManualItem?: boolean;
  },
  fallbackNombre = "Producto desconocido",
  fallbackPrecio = 0,
): VentaProducto => ({
  productoId: p.id || p.productoId || "",
  nombre: p.nombre || fallbackNombre,
  cantidad: p.quantity ?? p.cantidad ?? 1,
  precioUnitario: p.precioUnitario ?? p.precio ?? fallbackPrecio,
  precioLista: p.precioLista,
  precioMayorista: p.precioMayorista,
  esMayorista: p.esMayorista,
  esVIP: p.esVIP,
  vipDescuentoPct: p.vipDescuentoPct,
  tieneIVA: p.tieneIVA,
  porcentajeIVA: p.porcentajeIVA,
  peso: p.peso,
  precioPorKilo: p.precioPorKilo,
  variantKey: p.variantKey,
  variantesSeleccionadas: p.variantesSeleccionadas,
  skuVariante: p.skuVariante,
  modificadoresSeleccionados: p.modificadoresSeleccionados,
  modifierKey: p.modifierKey,
  isManualItem: p.isManualItem,
});
